import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { dehydrate, QueryClient } from '@tanstack/react-query';

import g from 'src/constants/urls';
import { IArticleByGroupDetail } from 'src/interface/ArticleByGroup';
import { ICategoryByGroupDetail } from 'src/interface/CategoryByGroup';
import wrapper from 'src/redux';

const HeadC = dynamic(() => import('src/components/Head'));
const EventDetailContainer = dynamic(() => import('src/containers/EventDetail/index'));

const DownloadContainer = dynamic(() => import('src/containers/Download'));
const BreadCrumbJsonLd = dynamic(() => import('src/components/Layout/JsonLd/Breadcrumb'));
const EventJsonLdC = dynamic(() => import('src/components/Layout/JsonLd/Event'));

const SubCategoryPage = (props: any) => {
	const event = props.event;
	const metaTitle = 'Event Kehamilan';
	const metaDescription = 'Event Kehamilan';

	return (
		<>
			<HeadC title={metaTitle} description={metaDescription} pageItem={event} />
			<EventDetailContainer {...props} />
			<DownloadContainer />
			<EventJsonLdC article={event} />
			<BreadCrumbJsonLd pageHeaderContent={props.pageHeaderContent} />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store: any) => async (ctx: any) => {
		let isError: boolean = false;
		let event: any = {};
		const queryClient = new QueryClient();
		const query = ctx.params;
		const subCategorySlug = query.sub;
		const uppercaseCount = (subCategorySlug.match(/[A-Z]/g) || []).length;

		try {
			const urievent = `${g.API_EVENT}/events/slug/${subCategorySlug.toLowerCase()}`;
			const optsEvent = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};
			const eventList = await fetch(urievent, optsEvent);
			event = await eventList.json().then((res) => ({ ...res, status: eventList.status }));
			if (uppercaseCount >= 1) {
				return {
					redirect: {
						destination: `/events/${subCategorySlug.toLowerCase()}`,
						statusCode: 301,
					},
				};
			}
		} catch (err: any) {
			if (err?.status === 400) {
				isError = true;
			} else {
				throw err;
			}
		}
		const subCategories: ICategoryByGroupDetail[] = store.getState().categoryByGroup.subCategories;
		const category = subCategories.find(
			(sc) => sc.slug === subCategorySlug,
		) as ICategoryByGroupDetail;

		const article: IArticleByGroupDetail[] =
			store.getState().articleByGroup.articleByCategory?.data?.records;

		if ((!category || !article) && isError) return { notFound: true };
		return {
			props: {
				dehydratedState: dehydrate(queryClient),
				card: true,
				isWhiteBackground: false,
				JsonLd: {
					organization: true,
					breadcrumbs: true,
				},
				pageHeaderContent: {
					title: 'event',
					breadcrumbs: [
						{ label: 'Event', navigatePath: '/event' },
						{ label: event.data.record.title },
					],
				},
				event: event.data.record || {},
				bc: [
					{ path: '/event', breadcrumbName: 'Semua Event' },
					{ breadcrumbName: event.data.record.title },
				],
			},
		};
	},
);

export default SubCategoryPage;
